import { type RouteLocationNormalizedGeneric } from "vue-router";

import features from "shared/services/features";
import { type Nullable } from "shared/types";

import useTeamPicker from "./useTeamPicker";

export default function useTeamRoute(route?: RouteLocationNormalizedGeneric) {
  const {
    organisationTeamFromId,
    selectedTeamPreference,
    updateTeamPreferenceMismatch,
  } = useTeamPicker(route);

  function isRouteRestricted(
    organisationTeamId: Nullable<number> = null,
    updatePreferenceIfMismatch: boolean = true
  ) {
    if (!organisationTeamId || !features.has("has_team_workspaces"))
      return false;

    const organisationTeam = organisationTeamFromId(organisationTeamId);

    if (organisationTeam) {
      if (updatePreferenceIfMismatch) {
        updateTeamPreferenceMismatch(organisationTeam.id);

        return false;
      }

      return selectedTeamPreference.value !== organisationTeamId;
    }

    return true;
  }

  function isPageRestricted(
    organisationTeamId: number,
    updatePreferenceIfMismatch: boolean = false
  ) {
    return isRouteRestricted(organisationTeamId, updatePreferenceIfMismatch);
  }

  return {
    isPageRestricted,
    isRouteRestricted,
  };
}
